import axios from 'axios';

const notificationsApi = axios.create( {
  baseURL: 'https://api.acordofechado.com.br/notification',
} );

notificationsApi.interceptors.request.use( async config => {
  const token = localStorage.getItem( 'af-token' );
  if ( token ) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
} );

export default notificationsApi;
